var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 29C17.5817 29 14 32.5817 14 37V91C14 95.4183 17.5817 99 22 99H106C110.418 99 114 95.4183 114 91V37C114 32.5817 110.418 29 106 29H22ZM106 30H22C20.2521 30 18.6538 30.6407 17.4271 31.7L64 68.3637L110.573 31.6999C109.346 30.6406 107.748 30 106 30ZM111.286 32.4111L71.2333 63.9421L111.286 95.5889C112.354 94.3601 113 92.7555 113 91V37C113 35.2444 112.354 33.6398 111.286 32.4111ZM63.6859 69.3891L64 69.6364L64.3033 69.3976L70.496 64.634L110.573 96.2999C109.346 97.3593 107.748 98 106 98H22C20.252 98 18.6537 97.3593 17.427 96.2999L57.5042 64.634L63.6859 69.3891ZM56.7668 63.9422L16.7138 32.4111C15.6462 33.6399 15 35.2445 15 37V91C15 92.7556 15.6463 94.3602 16.7139 95.5889L56.7668 63.9422Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 93,
    r: 20,
    fill: "#FECF29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 93L21.9244 86L21.244 86.6731L27.1581 92.524H11V93.4759H27.1582L21.244 99.3269L21.9244 100L29 93Z",
    fill: "#351648"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.12b2cc1b.svg";
export { ForwardRef as ReactComponent };